import { FC } from 'react';
import { RulesManagementAction, rulesValidityFilterSelector } from '@cbridge-modules/rules-management-page';
import { useDispatch, useSelector } from '@cbridge-utils/react-redux';
import { ClearFilterButton } from '@cbridge-tools/filters-panel';
import { isRuleFilterActive } from '@cbridge-tools/rules-data-grid-filter';

export const ClearErrorInvalidFilterButton: FC = () => {
  const dispatch = useDispatch();
  const validityFilter = useSelector(rulesValidityFilterSelector);

  const handleClearFilter = () => {
    dispatch(RulesManagementAction.resetValidityFilter());
  };

  return (
    <ClearFilterButton
      isShown={isRuleFilterActive(validityFilter)}
      onClick={handleClearFilter}
    />
  );
};
